import axios from 'axios';
import * as yup from 'yup';
import { dotPhraseSchema } from '~/schemas/dotPhraseSchema';
const responseSchema = yup
    .object()
    .camelCase()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
    data: yup.array().defined().of(dotPhraseSchema).ensure(),
});
export async function getDotPhrasesRequest() {
    const response = await axios.get('/api/dotPhrases');
    console.log('got dot phrases: ');
    console.log(response);
    const { data } = await responseSchema.validate(response.data);
    return {
        dotPhrases: data
    };
}
